var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetModuleStudioSubpanelsQuery } from "@/store/api";
import { ETCRM_URL } from "@/utils/const";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import SubpanelEditor from "./_subpanel";
export default function Subpanels() {
    var _a = useTranslation(["common", "ModuleBuilder"]), t = _a.t, i18n = _a.i18n;
    var _b = useParams(), packagesName = _b.packagesName, moduleName = _b.moduleName, type = _b.type, menu = _b.menu, dropdownName = _b.dropdownName, fieldName = _b.fieldName;
    var _c = useGetModuleStudioSubpanelsQuery({
        moduleName: moduleName,
        params: {
            lang: "fr_FR",
        },
    }), list_subpanels = _c.data, isFetching = _c.isFetching, isLoading = _c.isLoading, refetch = _c.refetch;
    var _d = useState([]), subpanels = _d[0], setSubpanels = _d[1];
    var _e = useState({}), imageErrors = _e[0], setImageErrors = _e[1];
    // Handler for image error
    var handleImageError = function (imageName) {
        setImageErrors(function (prevErrors) {
            var _a;
            return (__assign(__assign({}, prevErrors), (_a = {}, _a[imageName] = true, _a)));
        });
    };
    var getSubpanels = useCallback(function () {
        var _a;
        if ((_a = list_subpanels === null || list_subpanels === void 0 ? void 0 : list_subpanels.data) === null || _a === void 0 ? void 0 : _a.subpanels) {
            setSubpanels(list_subpanels.data.subpanels);
        }
    }, [list_subpanels]);
    var _f = useState(0), key = _f[0], setKey = _f[1];
    var rerender_test = fieldName === undefined ? "default" : fieldName;
    useEffect(function () {
        refetch();
        setKey(function (prevKey) { return prevKey + 1; });
    }, [rerender_test]);
    useEffect(function () {
        getSubpanels();
    }, [getSubpanels]);
    var navigate = useNavigate();
    var handleClick = function (value) {
        navigate("".concat(value.name), { state: { label: value.label } });
    };
    var Content = function () {
        return (_jsxs("div", __assign({ className: "flex flex-col max-h-[50vh] overflow-y-auto" }, { children: [_jsxs("div", __assign({ className: "mb-4 px-10 relative" }, { children: [_jsx("label", { children: Object.values(subpanels).length > 0
                                ? t("LBL_QUESTION_SUBPANEL", { ns: "ModuleBuilder" })
                                : list_subpanels && (_jsx("span", __assign({ className: " italic text-gray-300 " }, { children: t("LBL_NO_SUBPANEL_ADDED", { ns: "ModuleBuilder" }) }))) }), isLoading && (_jsxs("span", __assign({ className: " italic text-gray-300 " }, { children: [t("LBL_LISTING_THE_SUBPANEL_FOR", { ns: "ModuleBuilder" }), " ", moduleName, " ..."] })))] })), _jsx("div", __assign({ className: "grid grid-cols-4 gap-5 px-10" }, { children: Object.entries(subpanels).map(function (_a) {
                        var key = _a[0], value = _a[1];
                        return (_jsx("div", __assign({ className: " bg-[var(--color-brand-neutral-200)] text-gray-600 p-5 shadow-md rounded-md hover:bg-gray-500 hover:text-white  cursor-pointer" }, { children: _jsxs("div", __assign({ onClick: function () { return handleClick(value); }, className: "flex flex-col justify-center items-center " }, { children: [_jsx("img", { className: " ", src: "".concat(ETCRM_URL, "/themes/etcrm2/images/").concat(imageErrors[value.imageName]
                                            ? "icon_Fields.svg"
                                            : "".concat(value.imageName, ".svg")), alt: value.altImageName, width: value.size, height: value.size, title: value.imageTitle, color: "gray", onError: function () { return handleImageError(value.imageName); } }), _jsx("span", __assign({ className: "font-medium mt-2" }, { children: value.label }))] })) }), value.name));
                    }) }))] })));
    };
    return (_jsx("div", { children: fieldName ? _jsx(SubpanelEditor, {}) : _jsx(Content, {}) }, "".concat(key)));
}
